

import './ImagePreview.scss'
import Icon from '../utils/Icon'
import IconClose from '../icons/IconClose'
import { classify } from '../../helpers'

const ImagePreview = ({ value = true, onClose }) => {
	return (
		<div
			className={classify("img-preview fixed flex items-center justify-center", {
				'opacity-0 invisible': !value,
				'opacity-1 visible inset-0 z-50': value,
			})}
		>
			{value && <img src={value} alt='Post preview' className="max-h-screen mx-auto shadow-lg" />}
			<Icon
				name="close"
				stroke-width="2"
				className="h-12 w-12 absolute top-8 right-8 cursor-pointer opacity-60 hover:opacity-100"
				onClick={() => onClose && onClose()}
			>
				<IconClose />
			</Icon>
		</div >
	)
}

export default ImagePreview